export const GradientsList = () => (
  <svg className="hidden">
    <defs>
      <linearGradient
        id="green-gradient"
        x1="96.1288"
        y1="12.141"
        x2="134.064"
        y2="12.141"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B83E" />
        <stop offset="1" stopColor="#00B67D" />
      </linearGradient>
    </defs>

    <defs>
      <linearGradient
        id="pink-gradient"
        x1="0.357955"
        y1="20"
        x2="28"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B81D7A" />
        <stop offset="1" stopColor="#D6385E" />
      </linearGradient>
    </defs>
  </svg>
);
